import React ,{useState,useEffect}from 'react'
import {Button} from "react-bootstrap"
import ProductDetailNavbar from './ProductDetailNavbar'
import ProductDetails from './ProductDetails'
import Question from '../../Question/Question'
import Footer from "../../Footer/Footer"
import BottomNavbar from "../../BottomNavbar/BottomNavbar"
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";

export default function ProductDetailHome() {
  const [isMobile, setIsMobile] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const handleFeedback = (type) => {
      setFeedback(type);
      setSubmitted(true);
      // TODO: send to backend API if needed
    };
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      handleResize(); // initial check
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  return (
    <>
    <ProductDetailNavbar/>
    <ProductDetails/>
    <Question/>
    <br/>
    <div className="mt-4 p-3 border-top">
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{ textAlign: "center" }}>
              Was this information helpful?
            </p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}
              >
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{ textAlign: "center" }}>
            Thank you for your feedback! 🙏
          </p>
        )}
      </div>
    <br></br>
    <Footer/>
    <BottomNavbar/> 
  
    </>
  )
}
